import React, { useState, useEffect } from "react";
import inputFieldsMaps from "data/inputFieldsMaps";

import Dropdown from "components/organisms/Dropdown/Dropdown";
import { Subtitle } from "components/atoms/Subtitle/Subtitle";
import RedButton from "components/atoms/RedButton/RedButton";
import BorderButton from "components/atoms/BorderButton/BorderButton";
import ButtonsWrapper from "components/molecules/ButtonsWrapper/ButtonsWrapper";
import { Container } from "components/atoms/Container/Container";
import Step2Data from "data/Step2Data";
import GlobalData from "data/GlobalData";
import { Error } from "views/Step2.styles";
const Step2 = ({
  selectedChallenges,
  onHandleNextStep,
  onFilledFields,
  onHandleBackStep,
  inputValues,
  step,
  validationError,
  setValidationError,
  lang,
}) => {
  const [displayedInputValues, setDisplayedInputValues] = useState([]);
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(0);

  // Define a debounce function
  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleDebouncedActiveDropdownIndex = debounce((newIndex) => {
    setActiveDropdownIndex(newIndex);
  }, 2000);
  useEffect(() => {
    let inputFieldsMap;
    if (lang === "pl") {
      inputFieldsMap = inputFieldsMaps.pl;
    } else if (lang === "en") {
      inputFieldsMap = inputFieldsMaps.en;
    } else {
      inputFieldsMap = inputFieldsMaps.pl;
    }
    // Update displayed input values when selectedChallenges or inputValues change
    setDisplayedInputValues(
      selectedChallenges.map((challenge) => ({
        challenge,
        inputs: inputFieldsMap[challenge.id].map((field) => ({
          label: field.label,
          id: field.id,
          value: inputValues[field.id] || field.value,
          unit: field.unit,
          tip: field.tip,
        })),
      }))
    );
  }, [selectedChallenges, inputValues, lang]);

  const handleInputChange = (fieldId, value, inputs, challenge) => {
    const newInputValues = { ...inputValues, [fieldId]: value };
    if (fieldId === "B1" || fieldId === "D1") {
      const oppositeFieldId = fieldId === "B1" ? "D1" : "B1";
      const updatedInputValues = {
        ...newInputValues,
        [fieldId]: value,
        [oppositeFieldId]: value,
      };
      onFilledFields(updatedInputValues);
    } else {
      onFilledFields(newInputValues);
    }

    const currentIndex = displayedInputValues.findIndex(
      (data) => data.challenge.id === challenge.id
    );
    if (
      currentIndex < displayedInputValues.length - 1 &&
      inputs[inputs.length - 1].id === fieldId
    ) {
      handleDebouncedActiveDropdownIndex(activeDropdownIndex + 1);
    }
    const numericValue = parseFloat(value);
    if (numericValue <= 0 && fieldId !== "E1" && fieldId !== "E2") {
      setValidationError({
        ...validationError,
        [fieldId]:
          lang === "pl"
            ? GlobalData.validation.zero.pl
            : GlobalData.validation.zero.en,
      });
    } else if (value.trim() === "") {
      setValidationError({
        ...validationError,
        [fieldId]:
          lang === "pl"
            ? GlobalData.validation.empty.pl
            : GlobalData.validation.empty.en,
      });
    } else {
      setValidationError({ ...validationError, [fieldId]: null });
    }
  };

  const handleNext = () => {
    // Check if any fields are empty
    const newValidationError = { ...validationError };
    displayedInputValues.forEach(({ challenge, inputs }) => {
      inputs.forEach((field) => {
        if (field.value === 0) {
          newValidationError[field.id] =
            lang === "pl"
              ? GlobalData.validation.empty.pl
              : GlobalData.validation.empty.en;
        } else {
          newValidationError[field.id] = null;
        }
      });
    });
    setValidationError(newValidationError);
    if (Object.values(newValidationError).every((prop) => prop === null)) {
      onHandleNextStep(inputValues, displayedInputValues);
    }
  };
  const handleBack = (step) => {
    onHandleBackStep(step);
  };
  return (
    <Container>
      <Subtitle>
        {lang === "pl" ? Step2Data.subtitle.pl : Step2Data.subtitle.en}
      </Subtitle>
      {displayedInputValues &&
        displayedInputValues.map(({ challenge, inputs }, index) => (
          <Dropdown
            lang={lang}
            placeholder={GlobalData.placeholder.number}
            key={challenge.id}
            challenge={challenge}
            inputs={inputs}
            inputValues={inputValues}
            handleInputChange={handleInputChange}
            active={index === activeDropdownIndex ? true : false}
            validationError={validationError}
          />
        ))}
      {!Object.values(validationError).every((prop) => prop === null) && (
        <Error>
          {lang === "pl" ? Step2Data.moveon.pl : Step2Data.moveon.en}
        </Error>
      )}
      <ButtonsWrapper>
        <BorderButton onClick={() => handleBack(step)}>
          {lang === "pl"
            ? GlobalData.buttons.back.pl
            : GlobalData.buttons.back.en}
        </BorderButton>
        <RedButton
          disabled={
            Object.keys(validationError).length === 0 ||
            !Object.values(validationError).every((prop) => prop === null)
          }
          onClick={handleNext}
        >
          {lang === "pl"
            ? GlobalData.buttons.next.pl
            : GlobalData.buttons.next.en}
        </RedButton>
      </ButtonsWrapper>
    </Container>
  );
};

export default Step2;
